module.exports = __webpack_public_path__ + "images/df7e011d395682c470dbcdedb3120cfee232464bb3c28d159e777a505acfaf0f.svg";